module.exports = "/work-site/img/enter.85b40ea0.png";